import React, { Component } from 'react';
import PageTitle from '../../components/PageTitle';
import { connect } from 'react-redux';
import FirmwareActions, { request } from '../../redux/FirmwareRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import FirmwareForm from './components/FirmwareForm';
import Blanket from '@atlaskit/blanket';
import isEqual from 'react-fast-compare';
import ContentWrapper from '../../components/ContentWrapper';
import Forbidden from '../../components/Forbidden';
import { EditViewContext } from './components/EditViewContext';
import { withTranslation } from 'react-i18next';
import CommentForm from './components/CommentForm'
import History from './components/HistoryForm';

class FirmwarePage extends Component {
  constructor(props) {

    super(props);
    this.state = {
      edit: null,
      firmware: {
        id: 1,
        name: '',
        status: {},
        version: '',
        applicability: {},
        fileName: '',
        history: [],
      },
      comments: [],
      file: null,
      errors: {}
    };
  }

  componentDidMount() {
    const { get, getComments } = this.props;
    const requestedId = this.props.match.params.id;
    get(requestedId);
    getComments(requestedId);
  }

  componentDidUpdate(prevProps) {
    const { fetching } = this.props;

    if ((prevProps.fetching && !fetching && !this.props.error)) {
      this.setState({
        firmware: { ...this.props.firmware },
      });
    }

    if (!isEqual(prevProps.comments, this.props.comments)) {
      this.setState({ comments: this.props.comments });
    }

    if (prevProps.fetching && !fetching && !this.props.error) {
      this.setState({ edit: null });
    }
  }

  onFormSubmit = e => {
    e.preventDefault();
    const { update } = this.props;
    const { firmware, file } = this.state;

    let dataForUpdate = {};

    dataForUpdate['id'] = firmware['id'];
    dataForUpdate['applicabilityId'] = firmware.applicability.id;
    dataForUpdate['name'] = firmware['name'];
    dataForUpdate['statusId'] = firmware.status?.id;
    dataForUpdate['version'] = firmware.version;

    update(dataForUpdate, file);

    this.setState({ edit: null });
  }

  onDownload = () => {
    const requestedId = this.props.match.params.id;
    const { downloadFile } = this.props;

    downloadFile(requestedId, this.state.firmware?.fileName);
  };

  onFileChange = e => {
    const file = e.target.files[0];
    this.setState({
      file: file,
    });
  };

  onCancel = () => {
    this.setState({
      firmware: { ...this.props.firmware },
      edit: null,
    });
  }

  onChange = (name, value) => {
    this.setState({
      firmware: { ...this.state.firmware, [name]: value },
    });
  }

  onEditMode = formName => () => {
    if (!this.state.edit) {
      this.setState({ edit: formName })
    } else {
      this.setState({ edit: null })
    }
  }

  onCommentSubmit = (newComment) => {
    const requestedId = this.props.match.params.id;

    this.props.addComment(requestedId, newComment);
  };

  render() {
    const { edit, comments, file, firmware, errors } = this.state;

    const {
      fetching,
      commentFetching,
      dictionaries,
      getDictionaries,
      permissions,
      t,
    } = this.props;

    if (!permissions) {
      return <Forbidden />;
    }

    return (
      <EditViewContext.Provider
        value={{
          edit: this.state.edit,
          permissions: permissions,
          onChangeEditMode: this.onEditMode,
          onChange: this.onChange,
        }}>
        <ContentWrapper>
          <PageTitle>{t('Firmware details')}</PageTitle>
          <form onSubmit={this.onFormSubmit}>
            <FirmwareForm
              fetching={fetching}
              dictionaries={dictionaries}
              getDictionaries={getDictionaries}
              onCancel={this.onCancel}
              onDownload={this.onDownload}
              onFileChange={this.onFileChange}
              file={file}
              errors={errors}
              {...firmware}
            />
          </form>
          <Blanket
            onBlanketClicked={!this.props.allFetching && this.onCancel}
            isTinted={!!edit}
            canClickThrough={!edit}
          />
          <History history={firmware?.history} />
          <CommentForm
            comments={comments}  // Передаем существующие комментарии
            onCommentSubmit={this.onCommentSubmit}  // Метод для обработки отправки комментария
            fetching={commentFetching}
            dictionaries={dictionaries}
            getDictionaries={getDictionaries}
          />
        </ContentWrapper>
      </EditViewContext.Provider>
    );
  }
}

const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions.firmware,
    firmware: state.firmware.firmware,
    comments: state.firmware.comments,
    commentFetching: state.firmware.commentFetching,
    fetching: state.firmware.fetching,
    error: state.firmware.error,
    dictionaries: state.dictionaries,
    allFetching: state.firmware.fetching
  };
};

const mapDispatchToProps = dispatch => {
  return {
    get: id => dispatch(FirmwareActions.firmwareRequest(id)),
    update: (data, file) => dispatch(FirmwareActions.updateFirmwareWithFile(data, file)),
    delete: id => dispatch(FirmwareActions.firmwareDeleteRequest(id)),
    getComments: id => dispatch(FirmwareActions.firmwareCommentGetRequest(id)),
    addComment: (id, data) => dispatch(FirmwareActions.firmwareCommentAddRequest(id, data)),
    downloadFile: (id, fileName) => dispatch(FirmwareActions.firmwareFileDownloadRequest(id, fileName)),
    uploadFile: (id, formData) => dispatch(FirmwareActions.firmwareFileAddRequest(id, formData)),
    getDictionaries: name => () => dispatch(DictionariesActions.dictionariesRequest(name)),
  };
};

export default withTranslation('fota')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(FirmwarePage));
